module.exports = __webpack_public_path__ + "static/media/AdventureBay.b1ac849d.png";